/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.refreshFindifyRecommendation();
    });
    
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.refreshFindifyRecommendation();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  /**
   * Refresh Findify cart drawer recommendation
   * Re-initializes the Findify recommendation widget with current cart contents
   */
  refreshFindifyRecommendation() {
    if (typeof findify === 'undefined') return;

    findify.core.init.then(() => {
      const cartDrawerRecConfig = findify.recommendation.state['cart-findify-rec-6']?.config;
      
      if (!cartDrawerRecConfig) return;

      fetch('/cart.js')
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(cart => {
          const parameters = {
            cart: cart.items.map(item => ({
              id: item.product_id.toString(),
              vendor: item.vendor || '',
              type: item.product_type || ''
            }))
          };

          findify.recommendation.init({
            id: 'cart-findify-rec-6',
            parameters,
            ...cartDrawerRecConfig
          });
        })
        .catch(error => {
          console.warn('Findify recommendation refresh failed:', error);
        });
    });
  }
}

window.customElements.define('cart-drawer', CartDrawer);